import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';
import { Link } from 'react-router';
import { Cell } from 'fixed-data-table-2';
import forEach from 'lodash/forEach';
import get from 'lodash/get';

const propTypes = {
	data: PropTypes.array,
	type: PropTypes.string,
	title: PropTypes.string,
	rowIndex: PropTypes.number,
	classNameModify: PropTypes.string,
	onToggleExpandRow: PropTypes.func,
	rowsVisibilityConfig: PropTypes.object,
	conversionData: PropTypes.array
};

const AffOffer = props => {
	const { column } = props.data[props.rowIndex];
	const { method, rowRefsName } = props.rowsVisibilityConfig;
	const isCellTotal = column.is_total;
	const isOpened =
		(method === 'show' && rowRefsName.indexOf(column.affiliateRefs) === -1) ||
		(method === 'hide' && rowRefsName.indexOf(column.affiliateRefs) !== -1);
	let affiliate_id = null;

	forEach(props.conversionData, i => {
		if (i.offer && i.rows && get(i, 'rows[0].affiliate') === column.title) {
			affiliate_id = get( i, 'rows[0].affiliate_id');
		}
	});

	return (
		<Cell>
			<div
				className={cn(
					`activity-table-wrapper__cell activity-table-wrapper__cell--affOffer`,
					props.classNameModify && `activity-table-wrapper__cell--${props.classNameModify}`,
					isCellTotal && 'activity-table-wrapper__cell--total'
				)}
			>
				{ isCellTotal && (
					<div>
						<p className={column.grouping}>
							<span className='icon'>
								<Link to={`affiliates/profile/${affiliate_id}/`}></Link>
							</span>
							<span onClick={() => isCellTotal && props.onToggleExpandRow(column.affiliateRefs)}>
								{column.title || '-'}
							</span>
						</p>
						<span
							className={cn('expand__icon', isOpened && 'expand__icon--opened')}
							onClick={() => isCellTotal && props.onToggleExpandRow(column.affiliateRefs)}
						/>
					</div>
				) }

				{ !isCellTotal && (
					<p>
						<Link
							className="link"
							target="_blank"
							to={`/statistics/general?${column.linkToStat}`}>
							{column.title || '-'}
						</Link>
					</p>
				) }

			</div>
		</Cell>
	);
};

AffOffer.propTypes = propTypes;
export default AffOffer;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates-activity/components/table/cells/aff-offer.js